import Component from '@glimmer/component';
import type { CustomFieldSignature } from '../../types/tuition-assistance.ts';
import { formatReadonlyCustomFieldValue } from '../../utils/tuition-assistance/custom-field-value.ts';

export interface TuitionAssistanceProgramCustomReadonlyFieldSignature {
  Args: {
    customField: CustomFieldSignature;
  };
  Blocks: {
    default: [
      {
        isVisible: boolean;
        isRequired: boolean;
        programLabel: string;
        value: unknown;
        rawField: CustomFieldSignature;
      },
    ];
  };
}

export default class TuitionAssistanceProgramCustomReadonlyFieldComponent extends Component<TuitionAssistanceProgramCustomReadonlyFieldSignature> {
  get formattedValue() {
    const field = this.args.customField;
    const rawValues = field?.values || [];

    if (rawValues.length > 1) {
      // If value is an array with multiple items, return it. The value is meant to be an array.
      return rawValues.map((value) => this.formatValueIfApplicable(value));
    }

    // Otherwise we can assume the value is the single item in the array.
    const singleValue = rawValues[0];

    return this.formatValueIfApplicable(singleValue);
  }

  formatValueIfApplicable(value: string | boolean | undefined) {
    return formatReadonlyCustomFieldValue(value, this.args.customField);
  }

  <template>
    {{#let
      (hash
        isVisible=@customField.visible
        isRequired=@customField.required
        programLabel=@customField.label
        formattedValue=this.formattedValue
      )
      as |config|
    }}
      {{#if config.isVisible}}
        {{yield
          (hash
            isVisible=config.isVisible
            isRequired=config.isRequired
            programLabel=config.programLabel
            value=config.formattedValue
            rawField=@customField
          )
        }}
      {{/if}}
    {{/let}}
  </template>
}
